// This file is auto-generated by @hey-api/openapi-ts

import { type _JSONValue, defineQueryOptions, type UseMutationOptions } from '@pinia/colada'
import type { AxiosError } from 'axios'

import { serializeQueryKeyValue } from '../client'
import { client } from '../client.gen'
import {
  accessToken,
  addCollectionToCart,
  addOrderToCart,
  addQuoteLineItem,
  addToCollection,
  approveOrder,
  archiveCollection,
  archiveQuote,
  branding,
  categoryTree,
  changePassword,
  countLineItems,
  countNewQuotes,
  createAddress,
  createCollection,
  createLineItem,
  createLoginNetgoUser,
  createOrderRma,
  createQuoteRequest,
  dearchiveCollection,
  dearchiveQuote,
  deleteAddress,
  deleteCollection,
  deleteLineItem,
  deleteLineItem1,
  deleteLineItem2,
  deleteOrderItem,
  deletePreparedOrder,
  deleteQuoteRequest,
  deleteUser,
  duplicateCollection,
  emptyCart,
  featured,
  filterNodes,
  getActivity,
  getApprovableOrders,
  getApprovableOrdersFilterNodes,
  getCheckout,
  getCheckoutById,
  getCheckoutForQuote,
  getCheckoutTerms,
  getCollection,
  getCollectionFilters,
  getCollections,
  getComparison,
  getCurrentUser,
  getCustomTerms,
  getDataHtmlDatasheet,
  getDataHtmlDatasheet1,
  getDataHtmlDatasheet2,
  getDataHtmlDatasheet3,
  getEmployeeById,
  getFilterNodes,
  getFilters,
  getIsProductInQuoteRequest,
  getModelGroups,
  getMoveInfo,
  getOptimization,
  getOptimizations,
  getOrder,
  getOrderPreviews,
  getOrderRma,
  getOrders,
  getProductClass,
  getProductClasses,
  getProductInformation,
  getProductRequestMail,
  getQuoteRequest,
  getQuoteRequestForProduct,
  getSendCollectionMail,
  getTransactionHistory,
  getTransactionHistory1,
  impersonationStatus,
  initiatePasswordReset,
  inviteColleagues,
  inviteYourself,
  loadAccessoriesForProduct,
  loadBundleItemsForProduct,
  loadFullProduct,
  loadQuoteById,
  loadQuotes,
  login,
  moveLineItem,
  optimizeCart,
  type Options,
  patchOrderItem,
  postActivity,
  printQuote,
  readAddresses,
  readApprovers,
  readCompanyOrderLimit,
  readEmployees,
  readLineItems,
  readOrderLimitUsers,
  readSupplierCart,
  registerInvitedUser,
  rejectOrder,
  rejectQuote,
  requestCart,
  requestOrderById,
  requestQuote,
  requestQuote1,
  requestQuote2,
  runtimePrice,
  runtimePrices,
  searchForOrders,
  searchForSubsidiaries,
  searchProduct,
  searchProductSlice,
  selfRegister,
  sendCart,
  sendCartEprocurement,
  sendCartTopi,
  sendCollectionMail,
  sendProductRequestMail,
  sendQuote,
  sendQuoteEprocurement,
  sendQuoteRequest,
  settings,
  subsidiaries,
  switchToSubsidiary,
  updateAddress,
  updateCollection,
  updateCompanyOrderLimit,
  updateLineItem,
  updateLineItem1,
  updateLineItem2,
  updateOrder,
  updateOrderLimitUser,
  updateQuote,
  updateQuoteItem,
  updateQuoteRequest,
  updateTopiOrder,
  updateUser,
  updateUserCredentials,
  updateUserPermissions,
  updateUserSettings,
  uploadAvatar,
  validateAddressCheckout,
  validateEmails,
  validateEmails1,
  validateOrderNumber,
  validatePasswordChangeToken,
  validateRegisterToken
} from '../sdk.gen'
import type {
  AccessTokenData,
  AccessTokenError,
  AccessTokenResponse,
  AddCollectionToCartData,
  AddCollectionToCartError,
  AddCollectionToCartResponse,
  AddOrderToCartData,
  AddOrderToCartError,
  AddOrderToCartResponse,
  AddQuoteLineItemData,
  AddQuoteLineItemError,
  AddQuoteLineItemResponse,
  AddToCollectionData,
  AddToCollectionError,
  AddToCollectionResponse,
  ApproveOrderData,
  ApproveOrderError,
  ArchiveCollectionData,
  ArchiveCollectionError,
  ArchiveCollectionResponse,
  ArchiveQuoteData,
  ArchiveQuoteError,
  ArchiveQuoteResponse,
  BrandingData,
  BrandingError,
  BrandingResponse,
  CategoryTreeData,
  CategoryTreeError,
  CategoryTreeResponse,
  ChangePasswordData,
  ChangePasswordError,
  ChangePasswordResponse,
  CountLineItemsData,
  CountLineItemsError,
  CountLineItemsResponse,
  CountNewQuotesData,
  CountNewQuotesError,
  CountNewQuotesResponse,
  CreateAddressData,
  CreateAddressError,
  CreateCollectionData,
  CreateCollectionError,
  CreateCollectionResponse,
  CreateLineItemData,
  CreateLineItemError,
  CreateLineItemResponse,
  CreateLoginNetgoUserData,
  CreateLoginNetgoUserError,
  CreateLoginNetgoUserResponse,
  CreateOrderRmaData,
  CreateOrderRmaError,
  CreateQuoteRequestData,
  CreateQuoteRequestError,
  CreateQuoteRequestResponse,
  DearchiveCollectionData,
  DearchiveCollectionError,
  DearchiveCollectionResponse,
  DearchiveQuoteData,
  DearchiveQuoteError,
  DearchiveQuoteResponse,
  DeleteAddressData,
  DeleteAddressError,
  DeleteCollectionData,
  DeleteCollectionError,
  DeleteLineItem1Data,
  DeleteLineItem1Error,
  DeleteLineItem2Data,
  DeleteLineItem2Error,
  DeleteLineItemData,
  DeleteLineItemError,
  DeleteOrderItemData,
  DeleteOrderItemError,
  DeletePreparedOrderData,
  DeletePreparedOrderError,
  DeletePreparedOrderResponse,
  DeleteQuoteRequestData,
  DeleteQuoteRequestError,
  DeleteQuoteRequestResponse,
  DeleteUserData,
  DeleteUserError,
  DuplicateCollectionData,
  DuplicateCollectionError,
  DuplicateCollectionResponse,
  EmptyCartData,
  EmptyCartError,
  EmptyCartResponse,
  FeaturedData,
  FeaturedError,
  FeaturedResponse,
  FilterNodesData,
  FilterNodesError,
  FilterNodesResponse,
  GetActivityData,
  GetActivityError,
  GetApprovableOrdersData,
  GetApprovableOrdersError,
  GetApprovableOrdersFilterNodesData,
  GetApprovableOrdersFilterNodesError,
  GetApprovableOrdersFilterNodesResponse,
  GetApprovableOrdersResponse,
  GetCheckoutByIdData,
  GetCheckoutByIdError,
  GetCheckoutByIdResponse,
  GetCheckoutData,
  GetCheckoutError,
  GetCheckoutForQuoteData,
  GetCheckoutForQuoteError,
  GetCheckoutForQuoteResponse,
  GetCheckoutResponse,
  GetCheckoutTermsData,
  GetCheckoutTermsError,
  GetCheckoutTermsResponse,
  GetCollectionData,
  GetCollectionError,
  GetCollectionFiltersData,
  GetCollectionFiltersError,
  GetCollectionFiltersResponse,
  GetCollectionResponse,
  GetCollectionsData,
  GetCollectionsError,
  GetCollectionsResponse,
  GetComparisonData,
  GetComparisonError,
  GetCurrentUserData,
  GetCurrentUserError,
  GetCurrentUserResponse,
  GetCustomTermsData,
  GetCustomTermsError,
  GetCustomTermsResponse,
  GetDataHtmlDatasheet1Data,
  GetDataHtmlDatasheet1Error,
  GetDataHtmlDatasheet2Data,
  GetDataHtmlDatasheet2Error,
  GetDataHtmlDatasheet3Data,
  GetDataHtmlDatasheet3Error,
  GetDataHtmlDatasheetData,
  GetDataHtmlDatasheetError,
  GetEmployeeByIdData,
  GetEmployeeByIdError,
  GetFilterNodesData,
  GetFilterNodesError,
  GetFilterNodesResponse,
  GetFiltersData,
  GetFiltersError,
  GetIsProductInQuoteRequestData,
  GetIsProductInQuoteRequestError,
  GetIsProductInQuoteRequestResponse,
  GetModelGroupsData,
  GetModelGroupsError,
  GetModelGroupsResponse,
  GetMoveInfoData,
  GetMoveInfoError,
  GetMoveInfoResponse,
  GetOptimizationData,
  GetOptimizationError,
  GetOptimizationResponse,
  GetOptimizationsData,
  GetOptimizationsError,
  GetOptimizationsResponse,
  GetOrderData,
  GetOrderError,
  GetOrderPreviewsData,
  GetOrderPreviewsError,
  GetOrderPreviewsResponse,
  GetOrderRmaData,
  GetOrderRmaError,
  GetOrdersData,
  GetOrdersError,
  GetOrdersResponse,
  GetProductClassData,
  GetProductClassError,
  GetProductClassesData,
  GetProductClassesError,
  GetProductClassesResponse,
  GetProductClassResponse,
  GetProductInformationData,
  GetProductInformationError,
  GetProductInformationResponse,
  GetProductRequestMailData,
  GetProductRequestMailResponse,
  GetQuoteRequestData,
  GetQuoteRequestError,
  GetQuoteRequestForProductData,
  GetQuoteRequestForProductError,
  GetQuoteRequestForProductResponse,
  GetQuoteRequestResponse,
  GetSendCollectionMailData,
  GetSendCollectionMailResponse,
  GetTransactionHistory1Data,
  GetTransactionHistory1Error,
  GetTransactionHistory1Response,
  GetTransactionHistoryData,
  GetTransactionHistoryError,
  GetTransactionHistoryResponse,
  ImpersonationStatusData,
  ImpersonationStatusError,
  ImpersonationStatusResponse,
  InitiatePasswordResetData,
  InitiatePasswordResetResponse,
  InviteColleaguesData,
  InviteColleaguesResponse,
  InviteYourselfData,
  InviteYourselfError,
  InviteYourselfResponse,
  LoadAccessoriesForProductData,
  LoadAccessoriesForProductError,
  LoadBundleItemsForProductData,
  LoadBundleItemsForProductError,
  LoadFullProductData,
  LoadFullProductError,
  LoadFullProductResponse,
  LoadQuoteByIdData,
  LoadQuoteByIdError,
  LoadQuotesData,
  LoadQuotesError,
  LoadQuotesResponse,
  LoginData,
  LoginError,
  LoginResponse,
  MoveLineItemData,
  MoveLineItemError,
  OptimizeCartData,
  OptimizeCartError,
  OptimizeCartResponse,
  PatchOrderItemData,
  PatchOrderItemError,
  PostActivityData,
  PostActivityError,
  PrintQuoteData,
  PrintQuoteError,
  ReadAddressesData,
  ReadAddressesError,
  ReadAddressesResponse,
  ReadApproversData,
  ReadApproversError,
  ReadApproversResponse,
  ReadCompanyOrderLimitData,
  ReadCompanyOrderLimitError,
  ReadCompanyOrderLimitResponse,
  ReadEmployeesData,
  ReadEmployeesError,
  ReadLineItemsData,
  ReadLineItemsError,
  ReadLineItemsResponse,
  ReadOrderLimitUsersData,
  ReadOrderLimitUsersError,
  ReadOrderLimitUsersResponse,
  ReadSupplierCartData,
  ReadSupplierCartError,
  ReadSupplierCartResponse,
  RegisterInvitedUserData,
  RegisterInvitedUserResponse,
  RejectOrderData,
  RejectOrderError,
  RejectQuoteData,
  RejectQuoteError,
  RequestCartData,
  RequestCartError,
  RequestOrderByIdData,
  RequestOrderByIdError,
  RequestQuote1Data,
  RequestQuote1Error,
  RequestQuote1Response,
  RequestQuote2Data,
  RequestQuote2Error,
  RequestQuote2Response,
  RequestQuoteData,
  RequestQuoteError,
  RuntimePriceData,
  RuntimePriceError,
  RuntimePriceResponse,
  RuntimePricesData,
  RuntimePricesError,
  RuntimePricesResponse,
  SearchForOrdersData,
  SearchForOrdersError,
  SearchForOrdersResponse,
  SearchForSubsidiariesData,
  SearchForSubsidiariesError,
  SearchForSubsidiariesResponse,
  SearchProductData,
  SearchProductError,
  SearchProductResponse,
  SearchProductSliceData,
  SearchProductSliceError,
  SearchProductSliceResponse,
  SelfRegisterData,
  SelfRegisterError,
  SelfRegisterResponse,
  SendCartData,
  SendCartEprocurementData,
  SendCartEprocurementError,
  SendCartError,
  SendCartTopiData,
  SendCartTopiError,
  SendCartTopiResponse,
  SendCollectionMailData,
  SendCollectionMailResponse,
  SendProductRequestMailData,
  SendProductRequestMailResponse,
  SendQuoteData,
  SendQuoteEprocurementData,
  SendQuoteEprocurementError,
  SendQuoteError,
  SendQuoteRequestData,
  SendQuoteRequestError,
  SendQuoteRequestResponse,
  SettingsData,
  SettingsError,
  SettingsResponse,
  SubsidiariesData,
  SubsidiariesError,
  SubsidiariesResponse,
  SwitchToSubsidiaryData,
  SwitchToSubsidiaryError,
  SwitchToSubsidiaryResponse,
  UpdateAddressData,
  UpdateAddressError,
  UpdateCollectionData,
  UpdateCollectionError,
  UpdateCompanyOrderLimitData,
  UpdateCompanyOrderLimitError,
  UpdateCompanyOrderLimitResponse,
  UpdateLineItem1Data,
  UpdateLineItem1Error,
  UpdateLineItem2Data,
  UpdateLineItem2Error,
  UpdateLineItem2Response,
  UpdateLineItemData,
  UpdateLineItemError,
  UpdateOrderData,
  UpdateOrderError,
  UpdateOrderLimitUserData,
  UpdateOrderLimitUserError,
  UpdateOrderLimitUserResponse,
  UpdateQuoteData,
  UpdateQuoteError,
  UpdateQuoteItemData,
  UpdateQuoteItemError,
  UpdateQuoteRequestData,
  UpdateQuoteRequestError,
  UpdateQuoteRequestResponse,
  UpdateTopiOrderData,
  UpdateTopiOrderError,
  UpdateUserCredentialsData,
  UpdateUserCredentialsError,
  UpdateUserData,
  UpdateUserError,
  UpdateUserPermissionsData,
  UpdateUserPermissionsError,
  UpdateUserSettingsData,
  UpdateUserSettingsError,
  UpdateUserSettingsResponse,
  UploadAvatarData,
  UploadAvatarError,
  ValidateAddressCheckoutData,
  ValidateAddressCheckoutError,
  ValidateAddressCheckoutResponse,
  ValidateEmails1Data,
  ValidateEmails1Error,
  ValidateEmails1Response,
  ValidateEmailsData,
  ValidateEmailsError,
  ValidateEmailsResponse,
  ValidateOrderNumberData,
  ValidateOrderNumberError,
  ValidateOrderNumberResponse,
  ValidatePasswordChangeTokenData,
  ValidatePasswordChangeTokenResponse,
  ValidateRegisterTokenData,
  ValidateRegisterTokenResponse
} from '../types.gen'

/**
 * Update user avatar
 *
 * Update the avatar of the user identified by the id provided as path variable.Allowed image types: bmp, gif, jpeg, png, tiff. Returns the id of avatar.
 */
export const uploadAvatarMutation = (
  options?: Partial<Options<UploadAvatarData>>
): UseMutationOptions<unknown, Options<UploadAvatarData>, AxiosError<UploadAvatarError>> => ({
  mutation: async (vars) => {
    const { data } = await uploadAvatar({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Validate password-reset token.
 *
 * If the response to this action is 200 OK the token is valid. The token necessary for this validation can be retrieved from the initiate password reset action. This action enables token validation e.g. before the user is directed to the password reset page. Returns the used token.
 */
export const validatePasswordChangeTokenMutation = (
  options?: Partial<Options<ValidatePasswordChangeTokenData>>
): UseMutationOptions<
  ValidatePasswordChangeTokenResponse,
  Options<ValidatePasswordChangeTokenData>,
  AxiosError<Error>
> => ({
  mutation: async (vars) => {
    const { data } = await validatePasswordChangeToken({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Initiate password reset
 *
 * This is the first step in the process of resetting a password. When an user account exits for the requested email, an email is sent to the user. This mail contains a link to the password reset page. The link contains a token that has to be included in the further steps of this process. The second step in this process is validating is to validate the token before allowing the user to access the password change page. Returns the requested email address.
 */
export const initiatePasswordResetMutation = (
  options?: Partial<Options<InitiatePasswordResetData>>
): UseMutationOptions<
  InitiatePasswordResetResponse,
  Options<InitiatePasswordResetData>,
  AxiosError<Error>
> => ({
  mutation: async (vars) => {
    const { data } = await initiatePasswordReset({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

export const createLoginNetgoUserMutation = (
  options?: Partial<Options<CreateLoginNetgoUserData>>
): UseMutationOptions<
  CreateLoginNetgoUserResponse,
  Options<CreateLoginNetgoUserData>,
  AxiosError<CreateLoginNetgoUserError>
> => ({
  mutation: async (vars) => {
    const { data } = await createLoginNetgoUser({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Change password
 *
 * Change the password of the user identified by the provided token. The token necessary for this action can be received from the initiate password reset action. Before allowing a user to change their password, the token can be validated via the Validate password-change token action. Returns the used token.
 */
export const changePasswordMutation = (
  options?: Partial<Options<ChangePasswordData>>
): UseMutationOptions<
  ChangePasswordResponse,
  Options<ChangePasswordData>,
  AxiosError<ChangePasswordError>
> => ({
  mutation: async (vars) => {
    const { data } = await changePassword({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Load runtime prices for product ids, depending on realtime prices and scale
 */
export const runtimePricesMutation = (
  options?: Partial<Options<RuntimePricesData>>
): UseMutationOptions<
  RuntimePricesResponse,
  Options<RuntimePricesData>,
  AxiosError<RuntimePricesError>
> => ({
  mutation: async (vars) => {
    const { data } = await runtimePrices({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Load runtime prices for a given product id and scale, depending on realtime prices and scales
 */
export const runtimePriceMutation = (
  options?: Partial<Options<RuntimePriceData>>
): UseMutationOptions<
  RuntimePriceResponse,
  Options<RuntimePriceData>,
  AxiosError<RuntimePriceError>
> => ({
  mutation: async (vars) => {
    const { data } = await runtimePrice({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Self registration
 *
 * Returns email of new user.
 */
export const selfRegisterMutation = (
  options?: Partial<Options<SelfRegisterData>>
): UseMutationOptions<
  SelfRegisterResponse,
  Options<SelfRegisterData>,
  AxiosError<SelfRegisterError>
> => ({
  mutation: async (vars) => {
    const { data } = await selfRegister({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Validate email addresses
 *
 * Checks if emails are already in use, invited or invalid
 */
export const validateEmailsMutation = (
  options?: Partial<Options<ValidateEmailsData>>
): UseMutationOptions<
  ValidateEmailsResponse,
  Options<ValidateEmailsData>,
  AxiosError<ValidateEmailsError>
> => ({
  mutation: async (vars) => {
    const { data } = await validateEmails({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Self invitation
 *
 * Sends an invitation email to the given user email address
 */
export const inviteYourselfMutation = (
  options?: Partial<Options<InviteYourselfData>>
): UseMutationOptions<
  InviteYourselfResponse,
  Options<InviteYourselfData>,
  AxiosError<InviteYourselfError>
> => ({
  mutation: async (vars) => {
    const { data } = await inviteYourself({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Registration following invitation.
 *
 * Add new user whose email is encoded by the provided token. This token originates from the link to the registration page sent to users by invitation mails. Before allowing a user to access the registration page, the token can be validated by the Validate register-token action. Returns used token.
 */
export const registerInvitedUserMutation = (
  options?: Partial<Options<RegisterInvitedUserData>>
): UseMutationOptions<
  RegisterInvitedUserResponse,
  Options<RegisterInvitedUserData>,
  AxiosError<Error>
> => ({
  mutation: async (vars) => {
    const { data } = await registerInvitedUser({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Validate register-user token.
 *
 * If the response to this action is 200 OK the token is valid. This action can be used to validate a register-user token before allowing an invited user to access the registration page. This token originates in the link to the registration page sent to user's via invitation mails. Returns validated token.
 */
export const validateRegisterTokenMutation = (
  options?: Partial<Options<ValidateRegisterTokenData>>
): UseMutationOptions<
  ValidateRegisterTokenResponse,
  Options<ValidateRegisterTokenData>,
  AxiosError<Error>
> => ({
  mutation: async (vars) => {
    const { data } = await validateRegisterToken({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Reject quote by id
 *
 * Return id of hte rejected quote.
 */
export const rejectQuoteMutation = (
  options?: Partial<Options<RejectQuoteData>>
): UseMutationOptions<unknown, Options<RejectQuoteData>, AxiosError<RejectQuoteError>> => ({
  mutation: async (vars) => {
    const { data } = await rejectQuote({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'path'> & {
    _id: string
    baseURL?: _JSONValue
    body?: _JSONValue
    query?: _JSONValue
    tags?: _JSONValue
  }
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseURL: options?.baseURL || (options?.client ?? client).getConfig().baseURL
  } as QueryKey<TOptions>[0]
  if (tags) {
    params.tags = tags as unknown as _JSONValue
  }
  if (options?.body !== undefined) {
    const normalizedBody = serializeQueryKeyValue(options.body)
    if (normalizedBody !== undefined) {
      params.body = normalizedBody
    }
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query !== undefined) {
    const normalizedQuery = serializeQueryKeyValue(options.query)
    if (normalizedQuery !== undefined) {
      params.query = normalizedQuery
    }
  }
  return [params]
}

export const getActivityQueryKey = (options: Options<GetActivityData>) =>
  createQueryKey('getActivity', options)

/**
 * Load activity for quote by id
 */
export const getActivityQuery = defineQueryOptions<
  Options<GetActivityData>,
  unknown,
  AxiosError<GetActivityError>
>((options: Options<GetActivityData>) => ({
  key: getActivityQueryKey(options),
  query: async (context) => {
    const { data } = await getActivity({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

/**
 * Post activity for quote by id
 */
export const postActivityMutation = (
  options?: Partial<Options<PostActivityData>>
): UseMutationOptions<unknown, Options<PostActivityData>, AxiosError<PostActivityError>> => ({
  mutation: async (vars) => {
    const { data } = await postActivity({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Dearchive quote
 *
 * Returns id of dearchived quote
 */
export const dearchiveQuoteMutation = (
  options?: Partial<Options<DearchiveQuoteData>>
): UseMutationOptions<
  DearchiveQuoteResponse,
  Options<DearchiveQuoteData>,
  AxiosError<DearchiveQuoteError>
> => ({
  mutation: async (vars) => {
    const { data } = await dearchiveQuote({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Archive quote
 *
 * Returns id of archived quote
 */
export const archiveQuoteMutation = (
  options?: Partial<Options<ArchiveQuoteData>>
): UseMutationOptions<
  ArchiveQuoteResponse,
  Options<ArchiveQuoteData>,
  AxiosError<ArchiveQuoteError>
> => ({
  mutation: async (vars) => {
    const { data } = await archiveQuote({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Create new quote request
 *
 * Returns id of created quote
 */
export const createQuoteRequestMutation = (
  options?: Partial<Options<CreateQuoteRequestData>>
): UseMutationOptions<
  CreateQuoteRequestResponse,
  Options<CreateQuoteRequestData>,
  AxiosError<CreateQuoteRequestError>
> => ({
  mutation: async (vars) => {
    const { data } = await createQuoteRequest({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Delete quote request. Returns id of the deleted quote request.
 */
export const deleteQuoteRequestMutation = (
  options?: Partial<Options<DeleteQuoteRequestData>>
): UseMutationOptions<
  DeleteQuoteRequestResponse,
  Options<DeleteQuoteRequestData>,
  AxiosError<DeleteQuoteRequestError>
> => ({
  mutation: async (vars) => {
    const { data } = await deleteQuoteRequest({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

export const getQuoteRequestQueryKey = (options: Options<GetQuoteRequestData>) =>
  createQueryKey('getQuoteRequest', options)

/**
 * Get quote request
 */
export const getQuoteRequestQuery = defineQueryOptions<
  Options<GetQuoteRequestData>,
  GetQuoteRequestResponse,
  AxiosError<GetQuoteRequestError>
>((options: Options<GetQuoteRequestData>) => ({
  key: getQuoteRequestQueryKey(options),
  query: async (context) => {
    const { data } = await getQuoteRequest({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

/**
 * Update quote request. Returns id of the updated quote request
 */
export const updateQuoteRequestMutation = (
  options?: Partial<Options<UpdateQuoteRequestData>>
): UseMutationOptions<
  UpdateQuoteRequestResponse,
  Options<UpdateQuoteRequestData>,
  AxiosError<UpdateQuoteRequestError>
> => ({
  mutation: async (vars) => {
    const { data } = await updateQuoteRequest({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Add item to quote request. Returns id of the quote request.
 */
export const addQuoteLineItemMutation = (
  options?: Partial<Options<AddQuoteLineItemData>>
): UseMutationOptions<
  AddQuoteLineItemResponse,
  Options<AddQuoteLineItemData>,
  AxiosError<AddQuoteLineItemError>
> => ({
  mutation: async (vars) => {
    const { data } = await addQuoteLineItem({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Send quote request to portal owner. Returns id of the quote request.
 */
export const sendQuoteRequestMutation = (
  options?: Partial<Options<SendQuoteRequestData>>
): UseMutationOptions<
  SendQuoteRequestResponse,
  Options<SendQuoteRequestData>,
  AxiosError<SendQuoteRequestError>
> => ({
  mutation: async (vars) => {
    const { data } = await sendQuoteRequest({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Add order to cart
 *
 *  Returns successfulness of the operation.
 */
export const addOrderToCartMutation = (
  options?: Partial<Options<AddOrderToCartData>>
): UseMutationOptions<
  AddOrderToCartResponse,
  Options<AddOrderToCartData>,
  AxiosError<AddOrderToCartError>
> => ({
  mutation: async (vars) => {
    const { data } = await addOrderToCart({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Sends order
 *
 * Sends a prepared order. Order permission is necessary with no limit exceedance. Returns id of sent order.
 */
export const approveOrderMutation = (
  options?: Partial<Options<ApproveOrderData>>
): UseMutationOptions<unknown, Options<ApproveOrderData>, AxiosError<ApproveOrderError>> => ({
  mutation: async (vars) => {
    const { data } = await approveOrder({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

export const getOrderRmaQueryKey = (options: Options<GetOrderRmaData>) =>
  createQueryKey('getOrderRma', options)

/**
 * Get RMA process information for order
 */
export const getOrderRmaQuery = defineQueryOptions<
  Options<GetOrderRmaData>,
  unknown,
  AxiosError<GetOrderRmaError>
>((options: Options<GetOrderRmaData>) => ({
  key: getOrderRmaQueryKey(options),
  query: async (context) => {
    const { data } = await getOrderRma({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

/**
 * Request RMA process for some order positions
 */
export const createOrderRmaMutation = (
  options?: Partial<Options<CreateOrderRmaData>>
): UseMutationOptions<unknown, Options<CreateOrderRmaData>, AxiosError<CreateOrderRmaError>> => ({
  mutation: async (vars) => {
    const { data } = await createOrderRma({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Request approval for an existing order
 *
 * Order permission must be non-existent or order limit exceedance is necessary. Returns id of requested order.
 */
export const requestOrderByIdMutation = (
  options?: Partial<Options<RequestOrderByIdData>>
): UseMutationOptions<
  unknown,
  Options<RequestOrderByIdData>,
  AxiosError<RequestOrderByIdError>
> => ({
  mutation: async (vars) => {
    const { data } = await requestOrderById({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Rejects order
 *
 * Rejects a prepared order. Returns id of rejected order.
 */
export const rejectOrderMutation = (
  options?: Partial<Options<RejectOrderData>>
): UseMutationOptions<unknown, Options<RejectOrderData>, AxiosError<RejectOrderError>> => ({
  mutation: async (vars) => {
    const { data } = await rejectOrder({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Validate order number
 *
 * Check validity of self-created order number
 */
export const validateOrderNumberMutation = (
  options?: Partial<Options<ValidateOrderNumberData>>
): UseMutationOptions<
  ValidateOrderNumberResponse,
  Options<ValidateOrderNumberData>,
  AxiosError<ValidateOrderNumberError>
> => ({
  mutation: async (vars) => {
    const { data } = await validateOrderNumber({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Create order
 *
 * Create an order from quote. Order permission is necessary.
 */
export const sendQuoteMutation = (
  options?: Partial<Options<SendQuoteData>>
): UseMutationOptions<unknown, Options<SendQuoteData>, AxiosError<SendQuoteError>> => ({
  mutation: async (vars) => {
    const { data } = await sendQuote({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Create order
 *
 * Create an order from supplier cart. Order permission is necessary.
 */
export const sendCartMutation = (
  options?: Partial<Options<SendCartData>>
): UseMutationOptions<unknown, Options<SendCartData>, AxiosError<SendCartError>> => ({
  mutation: async (vars) => {
    const { data } = await sendCart({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

export const sendCartTopiMutation = (
  options?: Partial<Options<SendCartTopiData>>
): UseMutationOptions<
  SendCartTopiResponse,
  Options<SendCartTopiData>,
  AxiosError<SendCartTopiError>
> => ({
  mutation: async (vars) => {
    const { data } = await sendCartTopi({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Create an order from quote waiting for approval
 *
 * Order permission must be non-existent or order limit exceedance is necessary.
 */
export const requestQuoteMutation = (
  options?: Partial<Options<RequestQuoteData>>
): UseMutationOptions<unknown, Options<RequestQuoteData>, AxiosError<RequestQuoteError>> => ({
  mutation: async (vars) => {
    const { data } = await requestQuote({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Create an order from cart waiting for approval.
 *
 * Order permission must be non-existent or order limit exceedance is necessary.
 */
export const requestCartMutation = (
  options?: Partial<Options<RequestCartData>>
): UseMutationOptions<unknown, Options<RequestCartData>, AxiosError<RequestCartError>> => ({
  mutation: async (vars) => {
    const { data } = await requestCart({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Validate email address
 *
 * Checks if email address is already in use, invited or invalid
 */
export const validateEmails1Mutation = (
  options?: Partial<Options<ValidateEmails1Data>>
): UseMutationOptions<
  ValidateEmails1Response,
  Options<ValidateEmails1Data>,
  AxiosError<ValidateEmails1Error>
> => ({
  mutation: async (vars) => {
    const { data } = await validateEmails1({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

export const getSendCollectionMailQueryKey = (options: Options<GetSendCollectionMailData>) =>
  createQueryKey('getSendCollectionMail', options)

/**
 * Get preview email for a collection
 */
export const getSendCollectionMailQuery = defineQueryOptions<
  Options<GetSendCollectionMailData>,
  GetSendCollectionMailResponse,
  AxiosError<Error>
>((options: Options<GetSendCollectionMailData>) => ({
  key: getSendCollectionMailQueryKey(options),
  query: async (context) => {
    const { data } = await getSendCollectionMail({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

/**
 * Send email for a collection
 *
 * Returns serial of sent collection.
 */
export const sendCollectionMailMutation = (
  options?: Partial<Options<SendCollectionMailData>>
): UseMutationOptions<
  SendCollectionMailResponse,
  Options<SendCollectionMailData>,
  AxiosError<Error>
> => ({
  mutation: async (vars) => {
    const { data } = await sendCollectionMail({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

export const getProductRequestMailQueryKey = (options: Options<GetProductRequestMailData>) =>
  createQueryKey('getProductRequestMail', options)

/**
 * Get request email for a product with no price
 */
export const getProductRequestMailQuery = defineQueryOptions<
  Options<GetProductRequestMailData>,
  GetProductRequestMailResponse,
  AxiosError<Error>
>((options: Options<GetProductRequestMailData>) => ({
  key: getProductRequestMailQueryKey(options),
  query: async (context) => {
    const { data } = await getProductRequestMail({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

/**
 * Send request email for a product with no price
 *
 * Returns the serial of the requested product.
 */
export const sendProductRequestMailMutation = (
  options?: Partial<Options<SendProductRequestMailData>>
): UseMutationOptions<
  SendProductRequestMailResponse,
  Options<SendProductRequestMailData>,
  AxiosError<Error>
> => ({
  mutation: async (vars) => {
    const { data } = await sendProductRequestMail({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Invite new colleagues
 *
 * Send invitation emails to all email addresses in payload.
 */
export const inviteColleaguesMutation = (
  options?: Partial<Options<InviteColleaguesData>>
): UseMutationOptions<
  InviteColleaguesResponse,
  Options<InviteColleaguesData>,
  AxiosError<Error>
> => ({
  mutation: async (vars) => {
    const { data } = await inviteColleagues({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Load product
 *
 * Returns the product with the given product classes.
 */
export const getProductInformationMutation = (
  options?: Partial<Options<GetProductInformationData>>
): UseMutationOptions<
  GetProductInformationResponse,
  Options<GetProductInformationData>,
  AxiosError<GetProductInformationError>
> => ({
  mutation: async (vars) => {
    const { data } = await getProductInformation({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

export const getCollectionsQueryKey = (options?: Options<GetCollectionsData>) =>
  createQueryKey('getCollections', options)

/**
 * Get collections.
 *
 * Returns list of filtered and sorted collections
 */
export const getCollectionsQuery = defineQueryOptions<
  Options<GetCollectionsData>,
  GetCollectionsResponse,
  AxiosError<GetCollectionsError>
>((options?: Options<GetCollectionsData>) => ({
  key: getCollectionsQueryKey(options),
  query: async (context) => {
    const { data } = await getCollections({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

/**
 * Create new collection
 *
 * Returns the serial of the created collection
 */
export const createCollectionMutation = (
  options?: Partial<Options<CreateCollectionData>>
): UseMutationOptions<
  CreateCollectionResponse,
  Options<CreateCollectionData>,
  AxiosError<CreateCollectionError>
> => ({
  mutation: async (vars) => {
    const { data } = await createCollection({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Delete collection
 */
export const deleteCollectionMutation = (
  options?: Partial<Options<DeleteCollectionData>>
): UseMutationOptions<
  unknown,
  Options<DeleteCollectionData>,
  AxiosError<DeleteCollectionError>
> => ({
  mutation: async (vars) => {
    const { data } = await deleteCollection({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

export const getCollectionQueryKey = (options: Options<GetCollectionData>) =>
  createQueryKey('getCollection', options)

/**
 * Get collection
 */
export const getCollectionQuery = defineQueryOptions<
  Options<GetCollectionData>,
  GetCollectionResponse,
  AxiosError<GetCollectionError>
>((options: Options<GetCollectionData>) => ({
  key: getCollectionQueryKey(options),
  query: async (context) => {
    const { data } = await getCollection({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

/**
 * Update collection
 *
 * Returns the serial of the updated collection
 */
export const updateCollectionMutation = (
  options?: Partial<Options<UpdateCollectionData>>
): UseMutationOptions<
  unknown,
  Options<UpdateCollectionData>,
  AxiosError<UpdateCollectionError>
> => ({
  mutation: async (vars) => {
    const { data } = await updateCollection({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Add item to collection
 */
export const addToCollectionMutation = (
  options?: Partial<Options<AddToCollectionData>>
): UseMutationOptions<
  AddToCollectionResponse,
  Options<AddToCollectionData>,
  AxiosError<AddToCollectionError>
> => ({
  mutation: async (vars) => {
    const { data } = await addToCollection({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Add collection to cart
 *
 * Returns successfulness of the operation
 */
export const addCollectionToCartMutation = (
  options?: Partial<Options<AddCollectionToCartData>>
): UseMutationOptions<
  AddCollectionToCartResponse,
  Options<AddCollectionToCartData>,
  AxiosError<AddCollectionToCartError>
> => ({
  mutation: async (vars) => {
    const { data } = await addCollectionToCart({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Create quote request from collection
 *
 * Returns the serial of the created quote
 */
export const requestQuote2Mutation = (
  options?: Partial<Options<RequestQuote2Data>>
): UseMutationOptions<
  RequestQuote2Response,
  Options<RequestQuote2Data>,
  AxiosError<RequestQuote2Error>
> => ({
  mutation: async (vars) => {
    const { data } = await requestQuote2({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Duplicate collection
 *
 * Returns the serial of the new collection
 */
export const duplicateCollectionMutation = (
  options?: Partial<Options<DuplicateCollectionData>>
): UseMutationOptions<
  DuplicateCollectionResponse,
  Options<DuplicateCollectionData>,
  AxiosError<DuplicateCollectionError>
> => ({
  mutation: async (vars) => {
    const { data } = await duplicateCollection({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Dearchive collection
 *
 * Returns the serial of the dearchived collection
 */
export const dearchiveCollectionMutation = (
  options?: Partial<Options<DearchiveCollectionData>>
): UseMutationOptions<
  DearchiveCollectionResponse,
  Options<DearchiveCollectionData>,
  AxiosError<DearchiveCollectionError>
> => ({
  mutation: async (vars) => {
    const { data } = await dearchiveCollection({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Archive collection
 *
 * Returns the serial of the archived collection
 */
export const archiveCollectionMutation = (
  options?: Partial<Options<ArchiveCollectionData>>
): UseMutationOptions<
  ArchiveCollectionResponse,
  Options<ArchiveCollectionData>,
  AxiosError<ArchiveCollectionError>
> => ({
  mutation: async (vars) => {
    const { data } = await archiveCollection({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Optimize cart with given optimization type
 *
 * Returns "Optimization completed" upon completion.
 */
export const optimizeCartMutation = (
  options?: Partial<Options<OptimizeCartData>>
): UseMutationOptions<
  OptimizeCartResponse,
  Options<OptimizeCartData>,
  AxiosError<OptimizeCartError>
> => ({
  mutation: async (vars) => {
    const { data } = await optimizeCart({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Create cart item
 *
 * Returns id of new cart item.
 */
export const createLineItemMutation = (
  options?: Partial<Options<CreateLineItemData>>
): UseMutationOptions<
  CreateLineItemResponse,
  Options<CreateLineItemData>,
  AxiosError<CreateLineItemError>
> => ({
  mutation: async (vars) => {
    const { data } = await createLineItem({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Move cart item
 *
 * Returns id of target cart
 */
export const moveLineItemMutation = (
  options?: Partial<Options<MoveLineItemData>>
): UseMutationOptions<unknown, Options<MoveLineItemData>, AxiosError<MoveLineItemError>> => ({
  mutation: async (vars) => {
    const { data } = await moveLineItem({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Create quote request from cart
 *
 * Returns the id of the new quote.
 */
export const requestQuote1Mutation = (
  options?: Partial<Options<RequestQuote1Data>>
): UseMutationOptions<
  RequestQuote1Response,
  Options<RequestQuote1Data>,
  AxiosError<RequestQuote1Error>
> => ({
  mutation: async (vars) => {
    const { data } = await requestQuote1({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Empty the cart
 *
 * Removes all products from the cart. Returns the id of the cart.
 */
export const emptyCartMutation = (
  options?: Partial<Options<EmptyCartData>>
): UseMutationOptions<EmptyCartResponse, Options<EmptyCartData>, AxiosError<EmptyCartError>> => ({
  mutation: async (vars) => {
    const { data } = await emptyCart({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

export const readAddressesQueryKey = (options?: Options<ReadAddressesData>) =>
  createQueryKey('readAddresses', options)

/**
 * Get all addresses
 */
export const readAddressesQuery = defineQueryOptions<
  Options<ReadAddressesData>,
  ReadAddressesResponse,
  AxiosError<ReadAddressesError>
>((options?: Options<ReadAddressesData>) => ({
  key: readAddressesQueryKey(options),
  query: async (context) => {
    const { data } = await readAddresses({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

/**
 * Create new address
 */
export const createAddressMutation = (
  options?: Partial<Options<CreateAddressData>>
): UseMutationOptions<unknown, Options<CreateAddressData>, AxiosError<CreateAddressError>> => ({
  mutation: async (vars) => {
    const { data } = await createAddress({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Validate address for checkout
 */
export const validateAddressCheckoutMutation = (
  options?: Partial<Options<ValidateAddressCheckoutData>>
): UseMutationOptions<
  ValidateAddressCheckoutResponse,
  Options<ValidateAddressCheckoutData>,
  AxiosError<ValidateAddressCheckoutError>
> => ({
  mutation: async (vars) => {
    const { data } = await validateAddressCheckout({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Update user
 *
 * Update the user identified by the id provided as path variable
 */
export const updateUserMutation = (
  options?: Partial<Options<UpdateUserData>>
): UseMutationOptions<unknown, Options<UpdateUserData>, AxiosError<UpdateUserError>> => ({
  mutation: async (vars) => {
    const { data } = await updateUser({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Update user's settings
 *
 * Update settings of the user identified by id provided as path variable. Returns the id of the user.
 */
export const updateUserSettingsMutation = (
  options?: Partial<Options<UpdateUserSettingsData>>
): UseMutationOptions<
  UpdateUserSettingsResponse,
  Options<UpdateUserSettingsData>,
  AxiosError<UpdateUserSettingsError>
> => ({
  mutation: async (vars) => {
    const { data } = await updateUserSettings({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Update user's permissions
 *
 * Update permissions of the user identified by id provided as path variable. Returns the id of user.
 */
export const updateUserPermissionsMutation = (
  options?: Partial<Options<UpdateUserPermissionsData>>
): UseMutationOptions<
  unknown,
  Options<UpdateUserPermissionsData>,
  AxiosError<UpdateUserPermissionsError>
> => ({
  mutation: async (vars) => {
    const { data } = await updateUserPermissions({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Update user's credentials
 *
 * Update credentials of the user
 */
export const updateUserCredentialsMutation = (
  options?: Partial<Options<UpdateUserCredentialsData>>
): UseMutationOptions<
  unknown,
  Options<UpdateUserCredentialsData>,
  AxiosError<UpdateUserCredentialsError>
> => ({
  mutation: async (vars) => {
    const { data } = await updateUserCredentials({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

export const loadQuoteByIdQueryKey = (options: Options<LoadQuoteByIdData>) =>
  createQueryKey('loadQuoteById', options)

/**
 * Load quote by id
 */
export const loadQuoteByIdQuery = defineQueryOptions<
  Options<LoadQuoteByIdData>,
  unknown,
  AxiosError<LoadQuoteByIdError>
>((options: Options<LoadQuoteByIdData>) => ({
  key: loadQuoteByIdQueryKey(options),
  query: async (context) => {
    const { data } = await loadQuoteById({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

/**
 * Update quote
 */
export const updateQuoteMutation = (
  options?: Partial<Options<UpdateQuoteData>>
): UseMutationOptions<unknown, Options<UpdateQuoteData>, AxiosError<UpdateQuoteError>> => ({
  mutation: async (vars) => {
    const { data } = await updateQuote({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Update quote item
 *
 * Returns new timestamp of updated quote
 */
export const updateQuoteItemMutation = (
  options?: Partial<Options<UpdateQuoteItemData>>
): UseMutationOptions<unknown, Options<UpdateQuoteItemData>, AxiosError<UpdateQuoteItemError>> => ({
  mutation: async (vars) => {
    const { data } = await updateQuoteItem({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Delete item of quote request
 *
 * Returns id of the deleted quote
 */
export const deleteLineItemMutation = (
  options?: Partial<Options<DeleteLineItemData>>
): UseMutationOptions<unknown, Options<DeleteLineItemData>, AxiosError<DeleteLineItemError>> => ({
  mutation: async (vars) => {
    const { data } = await deleteLineItem({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Update item of quote request
 *
 * Returns id of the updated item.
 */
export const updateLineItemMutation = (
  options?: Partial<Options<UpdateLineItemData>>
): UseMutationOptions<unknown, Options<UpdateLineItemData>, AxiosError<UpdateLineItemError>> => ({
  mutation: async (vars) => {
    const { data } = await updateLineItem({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Delete order item
 *
 * Delete the order item identified by the ids provided as path variables.Deletes the whole order if the item to be deleted is the last item in the order.  Returns id of order.
 */
export const deleteOrderItemMutation = (
  options?: Partial<Options<DeleteOrderItemData>>
): UseMutationOptions<unknown, Options<DeleteOrderItemData>, AxiosError<DeleteOrderItemError>> => ({
  mutation: async (vars) => {
    const { data } = await deleteOrderItem({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Update order item
 *
 * Update the order item identified by the ids provided as path variables. Returns new timestamp for order.
 */
export const patchOrderItemMutation = (
  options?: Partial<Options<PatchOrderItemData>>
): UseMutationOptions<unknown, Options<PatchOrderItemData>, AxiosError<PatchOrderItemError>> => ({
  mutation: async (vars) => {
    const { data } = await patchOrderItem({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Update order
 *
 * Update the order identified by the id provided as path variable. Returns id of updated order.
 */
export const updateOrderMutation = (
  options?: Partial<Options<UpdateOrderData>>
): UseMutationOptions<unknown, Options<UpdateOrderData>, AxiosError<UpdateOrderError>> => ({
  mutation: async (vars) => {
    const { data } = await updateOrder({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Update OrderLimitUser
 *
 * Update the OrderLimitUser identified by the id provided as path variable.Returns the id of the updated user if successful.
 */
export const updateOrderLimitUserMutation = (
  options?: Partial<Options<UpdateOrderLimitUserData>>
): UseMutationOptions<
  UpdateOrderLimitUserResponse,
  Options<UpdateOrderLimitUserData>,
  AxiosError<UpdateOrderLimitUserError>
> => ({
  mutation: async (vars) => {
    const { data } = await updateOrderLimitUser({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

export const readCompanyOrderLimitQueryKey = (options?: Options<ReadCompanyOrderLimitData>) =>
  createQueryKey('readCompanyOrderLimit', options)

/**
 * Get the company order limit
 */
export const readCompanyOrderLimitQuery = defineQueryOptions<
  Options<ReadCompanyOrderLimitData>,
  ReadCompanyOrderLimitResponse,
  AxiosError<ReadCompanyOrderLimitError>
>((options?: Options<ReadCompanyOrderLimitData>) => ({
  key: readCompanyOrderLimitQueryKey(options),
  query: async (context) => {
    const { data } = await readCompanyOrderLimit({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

/**
 * Update DefaultOrderLimit
 *
 * Update the DefaultOrderLimit for your company. Returns "DefaultOrderLimit was updated!" if successful
 */
export const updateCompanyOrderLimitMutation = (
  options?: Partial<Options<UpdateCompanyOrderLimitData>>
): UseMutationOptions<
  UpdateCompanyOrderLimitResponse,
  Options<UpdateCompanyOrderLimitData>,
  AxiosError<UpdateCompanyOrderLimitError>
> => ({
  mutation: async (vars) => {
    const { data } = await updateCompanyOrderLimit({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Delete collection item
 *
 * Returns the serial of the deleted item and its collection
 */
export const deleteLineItem1Mutation = (
  options?: Partial<Options<DeleteLineItem1Data>>
): UseMutationOptions<unknown, Options<DeleteLineItem1Data>, AxiosError<DeleteLineItem1Error>> => ({
  mutation: async (vars) => {
    const { data } = await deleteLineItem1({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Update collection item
 *
 * Returns the serial of the updated item
 */
export const updateLineItem1Mutation = (
  options?: Partial<Options<UpdateLineItem1Data>>
): UseMutationOptions<unknown, Options<UpdateLineItem1Data>, AxiosError<UpdateLineItem1Error>> => ({
  mutation: async (vars) => {
    const { data } = await updateLineItem1({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Delete cart item
 *
 * Returns id of deleted cart item
 */
export const deleteLineItem2Mutation = (
  options?: Partial<Options<DeleteLineItem2Data>>
): UseMutationOptions<unknown, Options<DeleteLineItem2Data>, AxiosError<DeleteLineItem2Error>> => ({
  mutation: async (vars) => {
    const { data } = await deleteLineItem2({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Update cart item
 *
 * Returns new timestamp for updated cart
 */
export const updateLineItem2Mutation = (
  options?: Partial<Options<UpdateLineItem2Data>>
): UseMutationOptions<
  UpdateLineItem2Response,
  Options<UpdateLineItem2Data>,
  AxiosError<UpdateLineItem2Error>
> => ({
  mutation: async (vars) => {
    const { data } = await updateLineItem2({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Delete address
 *
 * Delete the address identified by the id provided as path variable.
 */
export const deleteAddressMutation = (
  options?: Partial<Options<DeleteAddressData>>
): UseMutationOptions<unknown, Options<DeleteAddressData>, AxiosError<DeleteAddressError>> => ({
  mutation: async (vars) => {
    const { data } = await deleteAddress({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

/**
 * Update address
 *
 * Update the address identified by the id provided as path variable
 */
export const updateAddressMutation = (
  options?: Partial<Options<UpdateAddressData>>
): UseMutationOptions<unknown, Options<UpdateAddressData>, AxiosError<UpdateAddressError>> => ({
  mutation: async (vars) => {
    const { data } = await updateAddress({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

export const readEmployeesQueryKey = (options?: Options<ReadEmployeesData>) =>
  createQueryKey('readEmployees', options)

/**
 * Get all employees
 */
export const readEmployeesQuery = defineQueryOptions<
  Options<ReadEmployeesData>,
  unknown,
  AxiosError<ReadEmployeesError>
>((options?: Options<ReadEmployeesData>) => ({
  key: readEmployeesQueryKey(options),
  query: async (context) => {
    const { data } = await readEmployees({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

/**
 * Delete user
 *
 * Returns the id of the deleted user
 */
export const deleteUserMutation = (
  options?: Partial<Options<DeleteUserData>>
): UseMutationOptions<unknown, Options<DeleteUserData>, AxiosError<DeleteUserError>> => ({
  mutation: async (vars) => {
    const { data } = await deleteUser({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

export const getEmployeeByIdQueryKey = (options: Options<GetEmployeeByIdData>) =>
  createQueryKey('getEmployeeById', options)

/**
 * Get user
 */
export const getEmployeeByIdQuery = defineQueryOptions<
  Options<GetEmployeeByIdData>,
  unknown,
  AxiosError<GetEmployeeByIdError>
>((options: Options<GetEmployeeByIdData>) => ({
  key: getEmployeeByIdQueryKey(options),
  query: async (context) => {
    const { data } = await getEmployeeById({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getCurrentUserQueryKey = (options?: Options<GetCurrentUserData>) =>
  createQueryKey('getCurrentUser', options)

/**
 * Get my user
 */
export const getCurrentUserQuery = defineQueryOptions<
  Options<GetCurrentUserData>,
  GetCurrentUserResponse,
  AxiosError<GetCurrentUserError>
>((options?: Options<GetCurrentUserData>) => ({
  key: getCurrentUserQueryKey(options),
  query: async (context) => {
    const { data } = await getCurrentUser({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const loginQueryKey = (options?: Options<LoginData>) => createQueryKey('login', options)

/**
 * Get refresh token for basic auth
 *
 * Endpoint to obtain refresh token for the storefront API based on basic auth credentials. Returns new refresh token.
 */
export const loginQuery = defineQueryOptions<
  Options<LoginData>,
  LoginResponse,
  AxiosError<LoginError>
>((options?: Options<LoginData>) => ({
  key: loginQueryKey(options),
  query: async (context) => {
    const { data } = await login({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const accessTokenQueryKey = (options: Options<AccessTokenData>) =>
  createQueryKey('accessToken', options)

/**
 * Get access token
 *
 * Endpoint to obtain access token for the storefront API based on refresh token
 */
export const accessTokenQuery = defineQueryOptions<
  Options<AccessTokenData>,
  AccessTokenResponse,
  AxiosError<AccessTokenError>
>((options: Options<AccessTokenData>) => ({
  key: accessTokenQueryKey(options),
  query: async (context) => {
    const { data } = await accessToken({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const subsidiariesQueryKey = (options?: Options<SubsidiariesData>) =>
  createQueryKey('subsidiaries', options)

/**
 * Get the companies' relations
 */
export const subsidiariesQuery = defineQueryOptions<
  Options<SubsidiariesData>,
  SubsidiariesResponse,
  AxiosError<SubsidiariesError>
>((options?: Options<SubsidiariesData>) => ({
  key: subsidiariesQueryKey(options),
  query: async (context) => {
    const { data } = await subsidiaries({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const switchToSubsidiaryQueryKey = (options: Options<SwitchToSubsidiaryData>) =>
  createQueryKey('switchToSubsidiary', options)

/**
 * Get access token for subsidiary
 *
 * Endpoint to obtain session tokens for the storefront API based on subsidiary
 */
export const switchToSubsidiaryQuery = defineQueryOptions<
  Options<SwitchToSubsidiaryData>,
  SwitchToSubsidiaryResponse,
  AxiosError<SwitchToSubsidiaryError>
>((options: Options<SwitchToSubsidiaryData>) => ({
  key: switchToSubsidiaryQueryKey(options),
  query: async (context) => {
    const { data } = await switchToSubsidiary({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const searchForSubsidiariesQueryKey = (options?: Options<SearchForSubsidiariesData>) =>
  createQueryKey('searchForSubsidiaries', options)

/**
 * Search companies' relations
 */
export const searchForSubsidiariesQuery = defineQueryOptions<
  Options<SearchForSubsidiariesData>,
  SearchForSubsidiariesResponse,
  AxiosError<SearchForSubsidiariesError>
>((options?: Options<SearchForSubsidiariesData>) => ({
  key: searchForSubsidiariesQueryKey(options),
  query: async (context) => {
    const { data } = await searchForSubsidiaries({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const impersonationStatusQueryKey = (options?: Options<ImpersonationStatusData>) =>
  createQueryKey('impersonationStatus', options)

/**
 * Check if you are in a subsidiary
 *
 * Returns the portal company and the relation of the user to it. Enum values: NONE = Is not impersonated. BRANCH: Is admin of main customer company impersonating a member of an branch company. OWNER: Is shop owner impersonating a customer.
 */
export const impersonationStatusQuery = defineQueryOptions<
  Options<ImpersonationStatusData>,
  ImpersonationStatusResponse,
  AxiosError<ImpersonationStatusError>
>((options?: Options<ImpersonationStatusData>) => ({
  key: impersonationStatusQueryKey(options),
  query: async (context) => {
    const { data } = await impersonationStatus({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const featuredQueryKey = (options?: Options<FeaturedData>) =>
  createQueryKey('featured', options)

/**
 * Get the dashboard
 *
 * Get the store's start page. This operation is pageable but does not support sorting.
 */
export const featuredQuery = defineQueryOptions<
  Options<FeaturedData>,
  FeaturedResponse,
  AxiosError<FeaturedError>
>((options?: Options<FeaturedData>) => ({
  key: featuredQueryKey(options),
  query: async (context) => {
    const { data } = await featured({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const searchProductSliceQueryKey = (options?: Options<SearchProductSliceData>) =>
  createQueryKey('searchProductSlice', options)

/**
 * [Deprecation: Since 29 September 2026 00:00:00 UTC] Search for products with the provided keyword. At least one filter or keyword is required. Keyword must be at least 2 chars. Use lastKey of previous slice to get next slice.
 *
 * Params are ?keyword=apple%20ipad&filters=MAN88&lastKey=123456&size=30&sort=... Parameter lastKey can be omitted or 0 if first slice is requested.
 */
export const searchProductSliceQuery = defineQueryOptions<
  Options<SearchProductSliceData>,
  SearchProductSliceResponse,
  AxiosError<SearchProductSliceError>
>((options?: Options<SearchProductSliceData>) => ({
  key: searchProductSliceQueryKey(options),
  query: async (context) => {
    const { data } = await searchProductSlice({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getCustomTermsQueryKey = (options?: Options<GetCustomTermsData>) =>
  createQueryKey('getCustomTerms', options)

/**
 * Get Custom Terms
 */
export const getCustomTermsQuery = defineQueryOptions<
  Options<GetCustomTermsData>,
  GetCustomTermsResponse,
  AxiosError<GetCustomTermsError>
>((options?: Options<GetCustomTermsData>) => ({
  key: getCustomTermsQueryKey(options),
  query: async (context) => {
    const { data } = await getCustomTerms({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const loadQuotesQueryKey = (options?: Options<LoadQuotesData>) =>
  createQueryKey('loadQuotes', options)

/**
 * Load quotes for portal
 */
export const loadQuotesQuery = defineQueryOptions<
  Options<LoadQuotesData>,
  LoadQuotesResponse,
  AxiosError<LoadQuotesError>
>((options?: Options<LoadQuotesData>) => ({
  key: loadQuotesQueryKey(options),
  query: async (context) => {
    const { data } = await loadQuotes({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const printQuoteQueryKey = (options: Options<PrintQuoteData>) =>
  createQueryKey('printQuote', options)

/**
 * Print quote by id
 */
export const printQuoteQuery = defineQueryOptions<
  Options<PrintQuoteData>,
  unknown,
  AxiosError<PrintQuoteError>
>((options: Options<PrintQuoteData>) => ({
  key: printQuoteQueryKey(options),
  query: async (context) => {
    const { data } = await printQuote({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getDataHtmlDatasheetQueryKey = (options: Options<GetDataHtmlDatasheetData>) =>
  createQueryKey('getDataHtmlDatasheet', options)

/**
 * Get datasheet for a quote item
 */
export const getDataHtmlDatasheetQuery = defineQueryOptions<
  Options<GetDataHtmlDatasheetData>,
  unknown,
  AxiosError<GetDataHtmlDatasheetError>
>((options: Options<GetDataHtmlDatasheetData>) => ({
  key: getDataHtmlDatasheetQueryKey(options),
  query: async (context) => {
    const { data } = await getDataHtmlDatasheet({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const countNewQuotesQueryKey = (options?: Options<CountNewQuotesData>) =>
  createQueryKey('countNewQuotes', options)

/**
 * Count new quotes for portal
 */
export const countNewQuotesQuery = defineQueryOptions<
  Options<CountNewQuotesData>,
  CountNewQuotesResponse,
  AxiosError<CountNewQuotesError>
>((options?: Options<CountNewQuotesData>) => ({
  key: countNewQuotesQueryKey(options),
  query: async (context) => {
    const { data } = await countNewQuotes({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getFiltersQueryKey = (options?: Options<GetFiltersData>) =>
  createQueryKey('getFilters', options)

/**
 * Load quote filters for portal
 */
export const getFiltersQuery = defineQueryOptions<
  Options<GetFiltersData>,
  unknown,
  AxiosError<GetFiltersError>
>((options?: Options<GetFiltersData>) => ({
  key: getFiltersQueryKey(options),
  query: async (context) => {
    const { data } = await getFilters({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getIsProductInQuoteRequestQueryKey = (
  options: Options<GetIsProductInQuoteRequestData>
) => createQueryKey('getIsProductInQuoteRequest', options)

/**
 * Is the product in any quote request
 */
export const getIsProductInQuoteRequestQuery = defineQueryOptions<
  Options<GetIsProductInQuoteRequestData>,
  GetIsProductInQuoteRequestResponse,
  AxiosError<GetIsProductInQuoteRequestError>
>((options: Options<GetIsProductInQuoteRequestData>) => ({
  key: getIsProductInQuoteRequestQueryKey(options),
  query: async (context) => {
    const { data } = await getIsProductInQuoteRequest({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getQuoteRequestForProductQueryKey = (
  options: Options<GetQuoteRequestForProductData>
) => createQueryKey('getQuoteRequestForProduct', options)

/**
 * Get quote request for product id.
 */
export const getQuoteRequestForProductQuery = defineQueryOptions<
  Options<GetQuoteRequestForProductData>,
  GetQuoteRequestForProductResponse,
  AxiosError<GetQuoteRequestForProductError>
>((options: Options<GetQuoteRequestForProductData>) => ({
  key: getQuoteRequestForProductQueryKey(options),
  query: async (context) => {
    const { data } = await getQuoteRequestForProduct({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const searchProductQueryKey = (options?: Options<SearchProductData>) =>
  createQueryKey('searchProduct', options)

/**
 * Search for products with the provided keyword. At least one filter or keyword is required. Keyword must be at least 2 chars.
 *
 * params are ?keyword=apple%20ipad&filters=MAN88&page=0&size=30&sort=...
 */
export const searchProductQuery = defineQueryOptions<
  Options<SearchProductData>,
  SearchProductResponse,
  AxiosError<SearchProductError>
>((options?: Options<SearchProductData>) => ({
  key: searchProductQueryKey(options),
  query: async (context) => {
    const { data } = await searchProduct({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const loadFullProductQueryKey = (options: Options<LoadFullProductData>) =>
  createQueryKey('loadFullProduct', options)

/**
 * Load a product identified by its id
 */
export const loadFullProductQuery = defineQueryOptions<
  Options<LoadFullProductData>,
  LoadFullProductResponse,
  AxiosError<LoadFullProductError>
>((options: Options<LoadFullProductData>) => ({
  key: loadFullProductQueryKey(options),
  query: async (context) => {
    const { data } = await loadFullProduct({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getDataHtmlDatasheet1QueryKey = (options: Options<GetDataHtmlDatasheet1Data>) =>
  createQueryKey('getDataHtmlDatasheet1', options)

/**
 * Datasheet for a product
 */
export const getDataHtmlDatasheet1Query = defineQueryOptions<
  Options<GetDataHtmlDatasheet1Data>,
  unknown,
  AxiosError<GetDataHtmlDatasheet1Error>
>((options: Options<GetDataHtmlDatasheet1Data>) => ({
  key: getDataHtmlDatasheet1QueryKey(options),
  query: async (context) => {
    const { data } = await getDataHtmlDatasheet1({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const filterNodesQueryKey = (options?: Options<FilterNodesData>) =>
  createQueryKey('filterNodes', options)

/**
 * Dynamic filters for product search with the provided search keyword and filters.
 */
export const filterNodesQuery = defineQueryOptions<
  Options<FilterNodesData>,
  FilterNodesResponse,
  AxiosError<FilterNodesError>
>((options?: Options<FilterNodesData>) => ({
  key: filterNodesQueryKey(options),
  query: async (context) => {
    const { data } = await filterNodes({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const loadBundleItemsForProductQueryKey = (
  options: Options<LoadBundleItemsForProductData>
) => createQueryKey('loadBundleItemsForProduct', options)

/**
 * Load bundle items for a given product
 */
export const loadBundleItemsForProductQuery = defineQueryOptions<
  Options<LoadBundleItemsForProductData>,
  unknown,
  AxiosError<LoadBundleItemsForProductError>
>((options: Options<LoadBundleItemsForProductData>) => ({
  key: loadBundleItemsForProductQueryKey(options),
  query: async (context) => {
    const { data } = await loadBundleItemsForProduct({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const loadAccessoriesForProductQueryKey = (
  options: Options<LoadAccessoriesForProductData>
) => createQueryKey('loadAccessoriesForProduct', options)

/**
 * Load accessories for a given product
 */
export const loadAccessoriesForProductQuery = defineQueryOptions<
  Options<LoadAccessoriesForProductData>,
  unknown,
  AxiosError<LoadAccessoriesForProductError>
>((options: Options<LoadAccessoriesForProductData>) => ({
  key: loadAccessoriesForProductQueryKey(options),
  query: async (context) => {
    const { data } = await loadAccessoriesForProduct({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getComparisonQueryKey = (options: Options<GetComparisonData>) =>
  createQueryKey('getComparison', options)

/**
 * Get Products with comparable data
 */
export const getComparisonQuery = defineQueryOptions<
  Options<GetComparisonData>,
  unknown,
  AxiosError<GetComparisonError>
>((options: Options<GetComparisonData>) => ({
  key: getComparisonQueryKey(options),
  query: async (context) => {
    const { data } = await getComparison({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const settingsQueryKey = (options?: Options<SettingsData>) =>
  createQueryKey('settings', options)

/**
 * Get the store's settings
 */
export const settingsQuery = defineQueryOptions<
  Options<SettingsData>,
  SettingsResponse,
  AxiosError<SettingsError>
>((options?: Options<SettingsData>) => ({
  key: settingsQueryKey(options),
  query: async (context) => {
    const { data } = await settings({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getOrdersQueryKey = (options?: Options<GetOrdersData>) =>
  createQueryKey('getOrders', options)

/**
 * Get all orders
 */
export const getOrdersQuery = defineQueryOptions<
  Options<GetOrdersData>,
  GetOrdersResponse,
  AxiosError<GetOrdersError>
>((options?: Options<GetOrdersData>) => ({
  key: getOrdersQueryKey(options),
  query: async (context) => {
    const { data } = await getOrders({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

/**
 * Delete prepared order
 *
 * Delete the prepared order identified by the id provided as path variable.  Returns id of deleted order.
 */
export const deletePreparedOrderMutation = (
  options?: Partial<Options<DeletePreparedOrderData>>
): UseMutationOptions<
  DeletePreparedOrderResponse,
  Options<DeletePreparedOrderData>,
  AxiosError<DeletePreparedOrderError>
> => ({
  mutation: async (vars) => {
    const { data } = await deletePreparedOrder({
      ...options,
      ...vars,
      throwOnError: true
    })
    return data
  }
})

export const getOrderQueryKey = (options: Options<GetOrderData>) =>
  createQueryKey('getOrder', options)

/**
 * Get order
 */
export const getOrderQuery = defineQueryOptions<
  Options<GetOrderData>,
  unknown,
  AxiosError<GetOrderError>
>((options: Options<GetOrderData>) => ({
  key: getOrderQueryKey(options),
  query: async (context) => {
    const { data } = await getOrder({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const updateTopiOrderQueryKey = (options: Options<UpdateTopiOrderData>) =>
  createQueryKey('updateTopiOrder', options)

/**
 * Update topi order
 */
export const updateTopiOrderQuery = defineQueryOptions<
  Options<UpdateTopiOrderData>,
  unknown,
  AxiosError<UpdateTopiOrderError>
>((options: Options<UpdateTopiOrderData>) => ({
  key: updateTopiOrderQueryKey(options),
  query: async (context) => {
    const { data } = await updateTopiOrder({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getTransactionHistoryQueryKey = (options: Options<GetTransactionHistoryData>) =>
  createQueryKey('getTransactionHistory', options)

/**
 * Get order history
 *
 * Get the history of all transactions of an order. Sorted from new to old.
 */
export const getTransactionHistoryQuery = defineQueryOptions<
  Options<GetTransactionHistoryData>,
  GetTransactionHistoryResponse,
  AxiosError<GetTransactionHistoryError>
>((options: Options<GetTransactionHistoryData>) => ({
  key: getTransactionHistoryQueryKey(options),
  query: async (context) => {
    const { data } = await getTransactionHistory({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getDataHtmlDatasheet2QueryKey = (options: Options<GetDataHtmlDatasheet2Data>) =>
  createQueryKey('getDataHtmlDatasheet2', options)

/**
 * Get order document
 */
export const getDataHtmlDatasheet2Query = defineQueryOptions<
  Options<GetDataHtmlDatasheet2Data>,
  unknown,
  AxiosError<GetDataHtmlDatasheet2Error>
>((options: Options<GetDataHtmlDatasheet2Data>) => ({
  key: getDataHtmlDatasheet2QueryKey(options),
  query: async (context) => {
    const { data } = await getDataHtmlDatasheet2({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getDataHtmlDatasheet3QueryKey = (options: Options<GetDataHtmlDatasheet3Data>) =>
  createQueryKey('getDataHtmlDatasheet3', options)

/**
 * Get order document for transaction
 */
export const getDataHtmlDatasheet3Query = defineQueryOptions<
  Options<GetDataHtmlDatasheet3Data>,
  unknown,
  AxiosError<GetDataHtmlDatasheet3Error>
>((options: Options<GetDataHtmlDatasheet3Data>) => ({
  key: getDataHtmlDatasheet3QueryKey(options),
  query: async (context) => {
    const { data } = await getDataHtmlDatasheet3({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const searchForOrdersQueryKey = (options: Options<SearchForOrdersData>) =>
  createQueryKey('searchForOrders', options)

/**
 * Search for orders
 */
export const searchForOrdersQuery = defineQueryOptions<
  Options<SearchForOrdersData>,
  SearchForOrdersResponse,
  AxiosError<SearchForOrdersError>
>((options: Options<SearchForOrdersData>) => ({
  key: searchForOrdersQueryKey(options),
  query: async (context) => {
    const { data } = await searchForOrders({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getOrderPreviewsQueryKey = (options?: Options<GetOrderPreviewsData>) =>
  createQueryKey('getOrderPreviews', options)

/**
 * Get all order previews
 */
export const getOrderPreviewsQuery = defineQueryOptions<
  Options<GetOrderPreviewsData>,
  GetOrderPreviewsResponse,
  AxiosError<GetOrderPreviewsError>
>((options?: Options<GetOrderPreviewsData>) => ({
  key: getOrderPreviewsQueryKey(options),
  query: async (context) => {
    const { data } = await getOrderPreviews({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const readOrderLimitUsersQueryKey = (options?: Options<ReadOrderLimitUsersData>) =>
  createQueryKey('readOrderLimitUsers', options)

/**
 * Get all OrderLimitUsers
 */
export const readOrderLimitUsersQuery = defineQueryOptions<
  Options<ReadOrderLimitUsersData>,
  ReadOrderLimitUsersResponse,
  AxiosError<ReadOrderLimitUsersError>
>((options?: Options<ReadOrderLimitUsersData>) => ({
  key: readOrderLimitUsersQueryKey(options),
  query: async (context) => {
    const { data } = await readOrderLimitUsers({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const readApproversQueryKey = (options?: Options<ReadApproversData>) =>
  createQueryKey('readApprovers', options)

/**
 * Get all approvers
 */
export const readApproversQuery = defineQueryOptions<
  Options<ReadApproversData>,
  ReadApproversResponse,
  AxiosError<ReadApproversError>
>((options?: Options<ReadApproversData>) => ({
  key: readApproversQueryKey(options),
  query: async (context) => {
    const { data } = await readApprovers({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getFilterNodesQueryKey = (options?: Options<GetFilterNodesData>) =>
  createQueryKey('getFilterNodes', options)

/**
 * Dynamic filters for product search with the provided search term.
 */
export const getFilterNodesQuery = defineQueryOptions<
  Options<GetFilterNodesData>,
  GetFilterNodesResponse,
  AxiosError<GetFilterNodesError>
>((options?: Options<GetFilterNodesData>) => ({
  key: getFilterNodesQueryKey(options),
  query: async (context) => {
    const { data } = await getFilterNodes({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getTransactionHistory1QueryKey = (options?: Options<GetTransactionHistory1Data>) =>
  createQueryKey('getTransactionHistory1', options)

/**
 * Get ordering conditions
 *
 * Get the history of all transactions of an order. Sorted from new to old.
 */
export const getTransactionHistory1Query = defineQueryOptions<
  Options<GetTransactionHistory1Data>,
  GetTransactionHistory1Response,
  AxiosError<GetTransactionHistory1Error>
>((options?: Options<GetTransactionHistory1Data>) => ({
  key: getTransactionHistory1QueryKey(options),
  query: async (context) => {
    const { data } = await getTransactionHistory1({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getApprovableOrdersQueryKey = (options?: Options<GetApprovableOrdersData>) =>
  createQueryKey('getApprovableOrders', options)

/**
 * Get all approvable orders
 */
export const getApprovableOrdersQuery = defineQueryOptions<
  Options<GetApprovableOrdersData>,
  GetApprovableOrdersResponse,
  AxiosError<GetApprovableOrdersError>
>((options?: Options<GetApprovableOrdersData>) => ({
  key: getApprovableOrdersQueryKey(options),
  query: async (context) => {
    const { data } = await getApprovableOrders({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getApprovableOrdersFilterNodesQueryKey = (
  options?: Options<GetApprovableOrdersFilterNodesData>
) => createQueryKey('getApprovableOrdersFilterNodes', options)

/**
 * Dynamic filters for product search with the provided search term.
 */
export const getApprovableOrdersFilterNodesQuery = defineQueryOptions<
  Options<GetApprovableOrdersFilterNodesData>,
  GetApprovableOrdersFilterNodesResponse,
  AxiosError<GetApprovableOrdersFilterNodesError>
>((options?: Options<GetApprovableOrdersFilterNodesData>) => ({
  key: getApprovableOrdersFilterNodesQueryKey(options),
  query: async (context) => {
    const { data } = await getApprovableOrdersFilterNodes({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const sendQuoteEprocurementQueryKey = (options: Options<SendQuoteEprocurementData>) =>
  createQueryKey('sendQuoteEprocurement', options)

/**
 * Create eprocurement order html
 *
 * Generates html to send the quote back to the eprocurement system. Order permission and punchout session is necessary.
 */
export const sendQuoteEprocurementQuery = defineQueryOptions<
  Options<SendQuoteEprocurementData>,
  unknown,
  AxiosError<SendQuoteEprocurementError>
>((options: Options<SendQuoteEprocurementData>) => ({
  key: sendQuoteEprocurementQueryKey(options),
  query: async (context) => {
    const { data } = await sendQuoteEprocurement({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const sendCartEprocurementQueryKey = (options?: Options<SendCartEprocurementData>) =>
  createQueryKey('sendCartEprocurement', options)

/**
 * Create eprocurement order html for supplier cart
 *
 * Generates html to send the order back to the eprocurement system. Order permission and punchout session is necessary.
 */
export const sendCartEprocurementQuery = defineQueryOptions<
  Options<SendCartEprocurementData>,
  unknown,
  AxiosError<SendCartEprocurementError>
>((options?: Options<SendCartEprocurementData>) => ({
  key: sendCartEprocurementQueryKey(options),
  query: async (context) => {
    const { data } = await sendCartEprocurement({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getProductClassesQueryKey = (options?: Options<GetProductClassesData>) =>
  createQueryKey('getProductClasses', options)

/**
 * Load all product classes
 */
export const getProductClassesQuery = defineQueryOptions<
  Options<GetProductClassesData>,
  GetProductClassesResponse,
  AxiosError<GetProductClassesError>
>((options?: Options<GetProductClassesData>) => ({
  key: getProductClassesQueryKey(options),
  query: async (context) => {
    const { data } = await getProductClasses({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getProductClassQueryKey = (options?: Options<GetProductClassData>) =>
  createQueryKey('getProductClass', options)

/**
 * Load all product classes for sku
 */
export const getProductClassQuery = defineQueryOptions<
  Options<GetProductClassData>,
  GetProductClassResponse,
  AxiosError<GetProductClassError>
>((options?: Options<GetProductClassData>) => ({
  key: getProductClassQueryKey(options),
  query: async (context) => {
    const { data } = await getProductClass({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getModelGroupsQueryKey = (options: Options<GetModelGroupsData>) =>
  createQueryKey('getModelGroups', options)

/**
 * Load all model groups for product class id
 */
export const getModelGroupsQuery = defineQueryOptions<
  Options<GetModelGroupsData>,
  GetModelGroupsResponse,
  AxiosError<GetModelGroupsError>
>((options: Options<GetModelGroupsData>) => ({
  key: getModelGroupsQueryKey(options),
  query: async (context) => {
    const { data } = await getModelGroups({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getCollectionFiltersQueryKey = (options?: Options<GetCollectionFiltersData>) =>
  createQueryKey('getCollectionFilters', options)

/**
 * Get filters applicable to collections.
 *
 * Sort options = DATE_ASC, DATE_DESC, LAST_MODIFIED, TITLE_DESC, TITLE_ASC
 */
export const getCollectionFiltersQuery = defineQueryOptions<
  Options<GetCollectionFiltersData>,
  GetCollectionFiltersResponse,
  AxiosError<GetCollectionFiltersError>
>((options?: Options<GetCollectionFiltersData>) => ({
  key: getCollectionFiltersQueryKey(options),
  query: async (context) => {
    const { data } = await getCollectionFilters({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getCheckoutQueryKey = (options?: Options<GetCheckoutData>) =>
  createQueryKey('getCheckout', options)

/**
 * Get checkout information for all carts
 */
export const getCheckoutQuery = defineQueryOptions<
  Options<GetCheckoutData>,
  GetCheckoutResponse,
  AxiosError<GetCheckoutError>
>((options?: Options<GetCheckoutData>) => ({
  key: getCheckoutQueryKey(options),
  query: async (context) => {
    const { data } = await getCheckout({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getCheckoutByIdQueryKey = (options: Options<GetCheckoutByIdData>) =>
  createQueryKey('getCheckoutById', options)

/**
 * Get checkout information for supplier cart
 */
export const getCheckoutByIdQuery = defineQueryOptions<
  Options<GetCheckoutByIdData>,
  GetCheckoutByIdResponse,
  AxiosError<GetCheckoutByIdError>
>((options: Options<GetCheckoutByIdData>) => ({
  key: getCheckoutByIdQueryKey(options),
  query: async (context) => {
    const { data } = await getCheckoutById({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getCheckoutForQuoteQueryKey = (options: Options<GetCheckoutForQuoteData>) =>
  createQueryKey('getCheckoutForQuote', options)

/**
 * Get checkout information for quote
 */
export const getCheckoutForQuoteQuery = defineQueryOptions<
  Options<GetCheckoutForQuoteData>,
  GetCheckoutForQuoteResponse,
  AxiosError<GetCheckoutForQuoteError>
>((options: Options<GetCheckoutForQuoteData>) => ({
  key: getCheckoutForQuoteQueryKey(options),
  query: async (context) => {
    const { data } = await getCheckoutForQuote({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getCheckoutTermsQueryKey = (options?: Options<GetCheckoutTermsData>) =>
  createQueryKey('getCheckoutTerms', options)

/**
 * Get checkout terms
 */
export const getCheckoutTermsQuery = defineQueryOptions<
  Options<GetCheckoutTermsData>,
  GetCheckoutTermsResponse,
  AxiosError<GetCheckoutTermsError>
>((options?: Options<GetCheckoutTermsData>) => ({
  key: getCheckoutTermsQueryKey(options),
  query: async (context) => {
    const { data } = await getCheckoutTerms({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const categoryTreeQueryKey = (options?: Options<CategoryTreeData>) =>
  createQueryKey('categoryTree', options)

/**
 * Get category tree
 */
export const categoryTreeQuery = defineQueryOptions<
  Options<CategoryTreeData>,
  CategoryTreeResponse,
  AxiosError<CategoryTreeError>
>((options?: Options<CategoryTreeData>) => ({
  key: categoryTreeQueryKey(options),
  query: async (context) => {
    const { data } = await categoryTree({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const readLineItemsQueryKey = (options?: Options<ReadLineItemsData>) =>
  createQueryKey('readLineItems', options)

/**
 * Get all supplierCarts
 */
export const readLineItemsQuery = defineQueryOptions<
  Options<ReadLineItemsData>,
  ReadLineItemsResponse,
  AxiosError<ReadLineItemsError>
>((options?: Options<ReadLineItemsData>) => ({
  key: readLineItemsQueryKey(options),
  query: async (context) => {
    const { data } = await readLineItems({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const readSupplierCartQueryKey = (options: Options<ReadSupplierCartData>) =>
  createQueryKey('readSupplierCart', options)

/**
 * Get cart items for supplierCartId
 */
export const readSupplierCartQuery = defineQueryOptions<
  Options<ReadSupplierCartData>,
  ReadSupplierCartResponse,
  AxiosError<ReadSupplierCartError>
>((options: Options<ReadSupplierCartData>) => ({
  key: readSupplierCartQueryKey(options),
  query: async (context) => {
    const { data } = await readSupplierCart({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getOptimizationsQueryKey = (options?: Options<GetOptimizationsData>) =>
  createQueryKey('getOptimizations', options)

/**
 * Get available optimization strategies
 */
export const getOptimizationsQuery = defineQueryOptions<
  Options<GetOptimizationsData>,
  GetOptimizationsResponse,
  AxiosError<GetOptimizationsError>
>((options?: Options<GetOptimizationsData>) => ({
  key: getOptimizationsQueryKey(options),
  query: async (context) => {
    const { data } = await getOptimizations({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getOptimizationQueryKey = (options?: Options<GetOptimizationData>) =>
  createQueryKey('getOptimization', options)

/**
 * Get optimization preview for any strategy available
 */
export const getOptimizationQuery = defineQueryOptions<
  Options<GetOptimizationData>,
  GetOptimizationResponse,
  AxiosError<GetOptimizationError>
>((options?: Options<GetOptimizationData>) => ({
  key: getOptimizationQueryKey(options),
  query: async (context) => {
    const { data } = await getOptimization({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const getMoveInfoQueryKey = (options?: Options<GetMoveInfoData>) =>
  createQueryKey('getMoveInfo', options)

/**
 * Get cart item move info
 *
 * Gives a map of cart item serials to supplier cart serials indication where the cart item can be moved to
 */
export const getMoveInfoQuery = defineQueryOptions<
  Options<GetMoveInfoData>,
  GetMoveInfoResponse,
  AxiosError<GetMoveInfoError>
>((options?: Options<GetMoveInfoData>) => ({
  key: getMoveInfoQueryKey(options),
  query: async (context) => {
    const { data } = await getMoveInfo({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const countLineItemsQueryKey = (options?: Options<CountLineItemsData>) =>
  createQueryKey('countLineItems', options)

/**
 * Get supplier cart items count for supplierCartId, or count of cart if none is passed
 */
export const countLineItemsQuery = defineQueryOptions<
  Options<CountLineItemsData>,
  CountLineItemsResponse,
  AxiosError<CountLineItemsError>
>((options?: Options<CountLineItemsData>) => ({
  key: countLineItemsQueryKey(options),
  query: async (context) => {
    const { data } = await countLineItems({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))

export const brandingQueryKey = (options?: Options<BrandingData>) =>
  createQueryKey('branding', options)

/**
 * Get the store's branding information
 *
 * Contains information and images that can be used to fill the login page. Does not need authorization.
 */
export const brandingQuery = defineQueryOptions<
  Options<BrandingData>,
  BrandingResponse,
  AxiosError<BrandingError>
>((options?: Options<BrandingData>) => ({
  key: brandingQueryKey(options),
  query: async (context) => {
    const { data } = await branding({
      ...options,
      ...context,
      throwOnError: true
    })
    return data
  }
}))
